module.exports = __webpack_public_path__ + "static/img/14.79c39327.jpg";